/* tslint:disable */
/* eslint-disable */
/**
 * Shopping Cart API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CartLoanInfosDto
 */
export interface CartLoanInfosDto {
    /**
     * 
     * @type {string}
     * @memberof CartLoanInfosDto
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof CartLoanInfosDto
     */
    clientPrice: number;
    /**
     * 
     * @type {number}
     * @memberof CartLoanInfosDto
     */
    discountPrice?: number;
}

/**
 * Check if a given object implements the CartLoanInfosDto interface.
 */
export function instanceOfCartLoanInfosDto(value: object): value is CartLoanInfosDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('clientPrice' in value) || value['clientPrice'] === undefined) return false;
    return true;
}

export function CartLoanInfosDtoFromJSON(json: any): CartLoanInfosDto {
    return CartLoanInfosDtoFromJSONTyped(json, false);
}

export function CartLoanInfosDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CartLoanInfosDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'clientPrice': json['clientPrice'],
        'discountPrice': json['discountPrice'] == null ? undefined : json['discountPrice'],
    };
}

export function CartLoanInfosDtoToJSON(json: any): CartLoanInfosDto {
    return CartLoanInfosDtoToJSONTyped(json, false);
}

export function CartLoanInfosDtoToJSONTyped(value?: CartLoanInfosDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'clientPrice': value['clientPrice'],
        'discountPrice': value['discountPrice'],
    };
}

